import { render } from "./LessonCard.vue?vue&type=template&id=03645483"
import script from "./LessonCard.vue?vue&type=script&lang=ts"
export * from "./LessonCard.vue?vue&type=script&lang=ts"

import "./LessonCard.vue?vue&type=style&index=0&id=03645483&lang=scss"
script.render = render

export default script